import { KngHeaderNavStateItem, KnHeaderCustomerState } from './definitions/kng-header-nav.interface';

export class KngHeaderNavFactory 
{
	public static buildState(): KngHeaderNavStateItem[] 
	{
		return [
			{
				mobilePanelIsOpen: false,
				cssClass: 'ui__nav__global',
				menu: [
					{
						id: '',
						isSelected: false,
						url: '',
						label: '',
						hideMenu: true,
						iconPath: '',
						altText: '',
						cssClass: '',
						submenu: []
					},
					{
						id: '',
						isSelected: false,
						url: '',
						label: '',
						iconPath: '',
						hideMenu: true,
						altText: '',
						cssClass: '',
						submenu: []
					},
					{
						id: '',
						isSelected: false,
						url: '',
						label: '',
						iconPath: '',
						hideMenu: true,
						altText: '',
						cssClass: '',
						submenu: []
					},
					{
						id: '',
						isSelected: false,
						url: '',
						label: '',
						iconPath: '',
						hideMenu: true,
						altText: '',
						cssClass: 'ui__nav__global__user',
						submenu: [
							{
								id: '',
								isSelected: false,
								url: 'app/roles-permissions',
								label: '',
								iconPath: '',
								hideMenu: false,
								altText: '',
								cssClass: 'ui__nav__global__user',
								submenu: []
							}
						]
					}
				]
			},
			{
				mobilePanelIsOpen: false,
				cssClass: 'ui__nav__portal',
				menu: [
					{
						id: '',
						isSelected: true,
						url: '',
						label: '',
						iconPath: '',
						hideMenu: true,
						altText: '',
						cssClass: '',
						submenu: []
					}
				]
			},
			{
				mobilePanelIsOpen: false,
				cssClass: 'ui__nav__mobile',
				menu: [
					{
						id: '',
						isSelected: false,
						url: '',
						label: '',
						iconPath: '',
						hideMenu: true,
						altText: '',
						cssClass: '',
						submenu: []
					}
				]
			}
		];
	}
	public static buildheaderCustomerState(): KnHeaderCustomerState 
	{
		return {
			hidden: false,
			warningNote: '',
			readOnly: '',
			endSession: '',
			username: ''
		};
	}
}
